import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PromocodeBannerEffects } from './store/promocode-banner.effects';
import { promocodeBannerReducer } from './store/promocode-banner.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([PromocodeBannerEffects]),
    StoreModule.forFeature('promocodeBanner', promocodeBannerReducer),
  ],
})
export class PromocodeBannerModule {}
